/**
 * Enums do contrato de `wms_locations` (M1 r3 — Localizações) e defaults de
 * FORMULÁRIO do gerador de rua.
 *
 * Os valores dos enums são o contrato wire congelado (ARQUITETURA-E-ADAPTACOES
 * §"Feedback do dono — M1 3ª rodada"); os rótulos PT-BR vivem no dicionário
 * (warehouseLabels). r3: `rack_kind` MORREU (rack é só peso + nº de andares),
 * status ganhou MAINTENANCE, ocupação (derivada de LPN/OS no M3/M5) nasce
 * FREE, e localizações VIRTUAIS (inventário fora do galpão) entram com código
 * livre — fora do mapa.
 */

/** Tipos FÍSICOS (galpão — aparecem no minimapa via rua/bloco quando têm rua). */
export const LOCATION_TYPES = ['RACK', 'STAGING_STREET', 'STAGING_DOCK', 'DOCK', 'FACTORY_IN', 'FACTORY_OUT', 'INCIDENT'];

/** Tipo VIRTUAL (r3): código livre, só inventário — nunca aparece no mapa. */
export const VIRTUAL_LOCATION_TYPE = 'VIRTUAL';

/** Status físico (manual). Ocupação é OUTRO eixo (derivado), não misturar. */
export const LOCATION_STATUSES = ['ACTIVE', 'BLOCKED', 'MAINTENANCE'];

/** Ocupação derivada de LPN/OS (M3/M5) — até lá o backend responde FREE. */
export const LOCATION_OCCUPANCIES = ['FREE', 'OCCUPIED', 'RESERVED'];

/** Defaults de FORMULÁRIO do gerador (sem rack_kind): 5 andares e a tabela
 * regressiva placeholder A1..A5 (PRD §5) — pré-preenchimento editável, nunca
 * regra de comportamento. */
export const DEFAULT_RACK_LEVELS = 5;
export const DEFAULT_RACK_WEIGHTS_BY_LEVEL = [1500, 1200, 1000, 800, 600];
